module.exports = __webpack_public_path__ + "static/media/drive.0ffb7392.svg";